import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLink } from '@grandvisionhq/frk-routing';
import '../../../services/tealium/dist/es/types/shared/products.js';
import '../../../services/tealium/dist/es/events/event-properties-provider.js';
import { useDispatchTrackClickEvent } from '../../../services/tealium/dist/es/events/use-track-click-event.js';
import '../../../services/tealium/dist/es/events/use-track-error-event.js';
import { useSessionStorage } from '@grandvisionhq/utils';
import { useIsGooglePaySupportedForCart } from '../../../hooks/use-is-google-pay-supported-for-cart.js';
import '../../../models/adyen/payment-type.js';
import { ExpressPaymentMethod, PaymentMethod } from '../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../models/googlePay/types.js';
import '../../../models/payment/types.js';
import '../../../models/paypal/context.js';
import { GooglePayButton } from './GooglePayExpressCheckoutButton.js';

const GooglePayExpressCheckoutButtonContainer = ({ cartId , cartHash , onClickHandler  })=>{
    const dispatchTealiumTrackEvent = useDispatchTrackClickEvent();
    const cartLink = useLink({
        route: 'cart.overview'
    });
    const expressCheckoutLink = useLink({
        route: 'express-checkout',
        params: swcHelpers.objectSpread({
            type: ExpressPaymentMethod.GOOGLE_PAY,
            returnPath: cartLink === null || cartLink === void 0 ? void 0 : cartLink.href,
            cartId
        }, cartHash ? {
            cartHash
        } : null)
    });
    const { isGooglePaySupportedForCart , called , loading , paymentConfiguration  } = useIsGooglePaySupportedForCart(cartId);
    const [_, setConfiguration] = useSessionStorage('payment-configuration', undefined, (value)=>!value
    );
    const handleOnClick = React.useCallback(()=>{
        dispatchTealiumTrackEvent({
            data_element_id: 'Summary_GooglePayCheckout',
            data_description: 'checkout_with_googlepay'
        });
        onClickHandler && onClickHandler(PaymentMethod.GOOGLE_PAY);
        setConfiguration(paymentConfiguration);
        expressCheckoutLink === null || expressCheckoutLink === void 0 ? void 0 : expressCheckoutLink.onClick();
    }, [
        dispatchTealiumTrackEvent,
        expressCheckoutLink,
        onClickHandler,
        paymentConfiguration,
        setConfiguration, 
    ]);
    if (!isGooglePaySupportedForCart || !called || loading) {
        return null;
    }
    if (!expressCheckoutLink) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(GooglePayButton, {
        onClick: handleOnClick
    });
};

export { GooglePayExpressCheckoutButtonContainer };
//# sourceMappingURL=GooglePayExpressCheckoutButtonContainer.js.map
